import { render, staticRenderFns } from "./PrintCertificatesModal.vue?vue&type=template&id=a16974e2"
import script from "./PrintCertificatesModal.vue?vue&type=script&lang=js"
export * from "./PrintCertificatesModal.vue?vue&type=script&lang=js"
import style0 from "./PrintCertificatesModal.vue?vue&type=style&index=0&id=a16974e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports